import { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { FilterBar, FilterSelect } from '../../components/ListControls';
import { Panel } from '../../components/Panel';
import { SrbCode } from '../../components/SrbCode';
import { StatusChip } from '../../components/StatusChip';
import { formatJordan, TASK_STATUSES, type Task } from '@serb/shared';
import { TASK_LABEL, TASK_TONE } from './model';

/** What you asked Claude to do, and where each job stands */
export function ClaudeTasksTable({ items }: { items: Task[] }) {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const w = search.trim().toLowerCase();
  const shown = items
    .filter((t) => status === 'all' || TASK_LABEL[t.status] === status)
    .filter((t) => !w || [t.task, t.code, t.result].join(' ').toLowerCase().includes(w));

  return (
    <Panel title="Claude's Tasks">
      <FilterBar placeholder="Search tasks…" search={search} onSearch={setSearch}>
        <FilterSelect
          label="Status"
          value={status}
          onChange={setStatus}
          options={TASK_STATUSES.map((x) => TASK_LABEL[x])}
        />
      </FilterBar>
      <DataTable<Task>
        rows={shown}
        rowKey={(t) => t.id}
        empty="No tasks match. Use “Give Claude a Task” on the Approvals page."
        columns={[
          { header: 'Task', primary: true, render: (t) => t.task },
          { header: 'Shipment', nowrap: true, render: (t) => (t.code ? <SrbCode code={t.code} /> : '–') },
          { header: 'When', nowrap: true, render: (t) => formatJordan(t.runAt ?? t.createdAt) },
          {
            header: 'Status',
            nowrap: true,
            render: (t) => <StatusChip label={TASK_LABEL[t.status]} tone={TASK_TONE[t.status]} />,
          },
          { header: 'Result', render: (t) => t.result || '–' },
          {
            header: '',
            nowrap: true,
            action: true,
            render: (t) =>
              t.cardId && (
                <Stack direction="row">
                  <Button component={RouterLink} to={`/approvals/${t.cardId}`} size="small" variant="outlined">
                    Review
                  </Button>
                </Stack>
              ),
          },
        ]}
      />
    </Panel>
  );
}
